import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { key: 1 }

import { computed } from "vue";
import LoadingComponent from "./LoadingComponent.vue";


export default /*@__PURE__*/_defineComponent({
  ...{ name: "GenericButton" },
  __name: 'GenericButton',
  props: {
  text: { type: String, required: false },
  class: { type: String, required: false },
  loading: { type: Boolean, required: false, default: false },
  disabled: { type: Boolean, required: false, default: false },
  variant: { type: String, required: false, default: "primary" },
},
  emits: ["click"],
  setup(__props, { emit: __emit }) {



const props = __props;

const emit = __emit;

const classByVariant = computed(() => {
  const disabledClass =
    props.disabled || props.loading
      ? "opacity-50 cursor-not-allowed! "
      : "cursor-pointer ";
  switch (props.variant) {
    case "primary":
      return (
        disabledClass +
        "bg-gradient-to-r from-primary-400 to-primary-900 text-white p-4 rounded-full"
      );
    case "secondary":
      return (
        disabledClass +
        "bg-primary-100 text-primary-900 p-4 rounded-full hover:bg-primary-200"
      );
    case "outline":
      return (
        disabledClass +
        "border border-primary-500 text-primary-500 p-4 rounded-full hover:bg-primary-50"
      );
    case "ghost":
      return (
        disabledClass + "text-primary-500 p-4 rounded-full hover:bg-primary-50"
      );
    case "error":
      return disabledClass + "bg-error text-white p-4 rounded-full";
    default:
      return (
        disabledClass +
        "bg-gradient-to-r from-primary-400 to-primary-900 text-white p-4 rounded-full"
      );
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(classByVariant.value + ' ' + props.class),
    disabled: props.disabled || props.loading,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, [
    (props.loading)
      ? (_openBlock(), _createBlock(LoadingComponent, { key: 0 }))
      : (props.text)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(props.text), 1))
        : _renderSlot(_ctx.$slots, "default", { key: 2 })
  ], 10, _hoisted_1))
}
}

})